"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var fileDefaultObject = function fileDefaultObject() {
  return {
    token: '',
    name: '',
    size: 0,
    isUploading: false,
    isUploaded: false
  };
};

var _default = fileDefaultObject;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/constants/uploadFileSchemaForZendesk.js
// module id = 769
// module chunks = 33